import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import session from '../../../../share/session';

/** 
 * Dispose処理
 * @param {object} self this インスタンス
 */
export async function dispose(self) {
  try {
    self.isLoading = true;
    // バックエンドAPI POST,GET
    const token = session.getToken();
    await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'dispose',
      },
      // エラー発生のコールバックを実装
      undefined,
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result, 'dispose'); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result, 'dispose'); },
    );
  } finally {
    self.isLoading = false;
  }
}